"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertClientV2 = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class AlertClientV2 extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.version = 'v2';
    }
    getCount(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/${this.version}/projects/${projectId}/users/me/alerts/count`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    create(projectId, userAlertCreateRequest) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/${this.version}/projects/${projectId}/users/me/alerts`;
            const response = yield this.httpPost(url, userAlertCreateRequest);
            return response.payload;
        });
    }
    findById(projectId, id, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let url = `/${this.version}/projects/${projectId}/alerts/${id}`;
            if (fields)
                url = `${url}?${this.getQueryString({
                    fields,
                })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    findMyAlertById(projectId, id, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let url = `/${this.version}/projects/${projectId}/users/me/alerts/${id}`;
            if (fields)
                url = `${url}?${this.getQueryString({
                    fields,
                })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    findAll(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/${this.version}/projects/${projectId}/users/me/alerts`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    update(projectId, alertId, userAlertUpdateRequest) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/${this.version}/projects/${projectId}/users/me/alerts/${alertId}`;
            const response = yield this.httpPut(url, userAlertUpdateRequest);
            return response.payload;
        });
    }
    delete(projectId, alertId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/${this.version}/projects/${projectId}/users/me/alerts/${alertId}`;
            yield this.httpDelete(url);
        });
    }
    shareUserAlert(projectId, alertId, userAlertSharedCreateRequest) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/${this.version}/projects/${projectId}/users/me/alerts/${alertId}/share`;
            const response = yield this.httpPost(url, userAlertSharedCreateRequest);
            return response.payload;
        });
    }
}
exports.AlertClientV2 = AlertClientV2;
//# sourceMappingURL=alert.v2.client.js.map